function FollowUpBox() {
  return (
    <div className="step-card">
      <div className="step-number">4</div>
      <h3>Uppföljning</h3>
      <p>Få feedback och se hur det gick efter slutfört uppdrag</p>
    </div>
  );
}

export default FollowUpBox;
